import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

/**
 * Movimientos de crédito. Query propia (no generada por codegen, que solo escanea
 * los `.graphql`). Alineada con `Query.portalCreditMovements` del gateway, que
 * acepta filtro por `channel` y paginación (`take`/`skip`) — no rango de fecha.
 */
const MOVEMENTS = gql`
  query PortalCreditMovements(
    $businessId: String!
    $take: Int
    $skip: Int
    $channel: String
  ) {
    portalCreditMovements(
      businessId: $businessId
      take: $take
      skip: $skip
      channel: $channel
    ) {
      items {
        id
        amount
        deliveryChannel
        currencyId
        createdAt
      }
      totalItems
    }
  }
`

export interface CreditMovement {
  id: number
  amount: number
  deliveryChannel: string
  currencyId?: number | null
  createdAt?: string | null
}

interface MovementsResult {
  portalCreditMovements: { items: CreditMovement[]; totalItems: number }
}

interface UseCreditMovementsArgs {
  businessId: string | undefined
  take: number
  skip: number
  channel?: string | null
}

/** Historial paginado de movimientos de crédito, con filtro por tipo (canal). */
export function useCreditMovements({
  businessId,
  take,
  skip,
  channel,
}: UseCreditMovementsArgs) {
  const { data, loading, error, refetch } = useQuery<MovementsResult>(MOVEMENTS, {
    variables: {
      businessId: businessId ?? '',
      take,
      skip,
      channel: channel ?? null,
    },
    skip: !businessId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    movements: data?.portalCreditMovements.items ?? [],
    totalItems: data?.portalCreditMovements.totalItems ?? 0,
    loading,
    error,
    refetch,
  }
}
